interface Props {
  children: React.ReactNode;
}

const Panel = ({ children }: Props) => {
  return (
    <div className="panel pb-6 mb-6 border-b border-amber-500 border-dashed">
      {children}
    </div>
  );
};

export default Panel;
